import { Breadcrumb as AntBreadcrumb } from 'antd'
import type { BreadcrumbProps } from 'antd'
import './style.scss'

export const Breadcrumb = (props: BreadcrumbProps) => {
  return <AntBreadcrumb separator=">" {...props} />
}


export const BreadcrumbItem =  AntBreadcrumb.Item